let SentryRaven;

if (process.env.REACT_APP_SENTRY_DSN && process.env.NODE_ENV !== 'test') {
  // eslint-disable-next-line global-require
  SentryRaven = require('raven-js');
  SentryRaven.config(process.env.REACT_APP_SENTRY_DSN).install();
}

const Raven = SentryRaven;

export default Raven;



// WEBPACK FOOTER //
// ./src/sentry.js